import { useEffect, useState } from 'react'
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { useInView } from 'react-intersection-observer';
import './FeatureView.css';

function FeatureView() {

    const [isMdOrLarger, setIsMdOrLarger] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const isLargeEnough = window.innerWidth >= 900; 
            setIsMdOrLarger(isLargeEnough);
        };

        window.addEventListener('resize', handleResize);

        handleResize(); // Check on initial render

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Elements are outside the viewport causing overflow, 
    // Need to figure out how to place them inside the viewport initially while keeping the slide in animations
    const [ref1, inView1] = useInView({
        triggerOnce: true, // Only trigger once
        threshold: 0.1,
        // temporary fix to initial overflow problem
    });

    const [ref2, inView2] = useInView({
        triggerOnce: true,
        threshold: 0.2,
        // temporary fix to initial overflow problem
    });

    const [ref3, inView3] = useInView({
        triggerOnce: true,
        threshold: 0.02,
        // temporary fix to initial overflow problem
    });

    return (
        <div className='feature-container background-primary'>
            <Container maxWidth="xl">
                <h1 className='feature-title text-title'>
                    The Best AR Experience For You and Your Clients
                </h1>
                <Grid container sx={{ py: "2em"}} spacing={6}>
                    {/* Feature 1 */}
                    <Grid item xs={12} md={4} ref={ref1} className={isMdOrLarger ? inView1 ? 'show-feature' : 'slide-left' : 'show-feature'}>
                    
                        <div className='feature-info-left'>
                            <div className='text-heading'>Effortless Photorealistic Visualizations</div>
                            <p className='feature-info-paragraph text-description'>Blankwall automatically generates 3D models from your existing product listings.<br/> No manual per-product setup, and no additional work to support new products. Show products true to scale and color in customers' spaces.</p>
                        </div>
                    </Grid>

                    <Grid item xs={12} md={8}>
                        <div className='feature-image-normal'>
                            <img src="Feature-1.png" alt='color-accurate' className='feature-image' />
                        </div>
                    </Grid>

                    {/* Try highlighting some key words using different color to make the text less dull */}
                    {/* Maybe turn the 3 sentences into a list */}
                    {/* Feature 2 */}
                    <Grid item xs={12} md={8} sx={{ order: { xs: 2, md: 1 } }}>
                        <div className='feature-image-reverse'>
                            <img src="Feature-2.png" alt="custom-frame" className='feature-image' />
                        </div>
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ order: { xs: 1, md: 2 } }} ref={ref2} className={isMdOrLarger ? inView2 ? 'show-feature' : 'slide-right' : 'show-feature'}>
                        <div className='feature-info-right'>
                            <div className='text-heading'>
                                Customizable <br className='sm:block hidden'/>Frames
                            </div>
                            <p className='feature-info-paragraph text-description'>Showcase your catalog with our frame presets for a stunning result. 
                            <br/>Have your own design? Use our Custom Frame tool to build your own presets.
                            </p>
                        </div>
                    </Grid>

                </Grid>

                {/* Feature Column */}
                <Grid container sx={{ py: "2em"}} spacing={6}>
                    {/* No redirect */}
                    <Grid item xs={12} md={6} ref={ref3} className={isMdOrLarger ? inView3 ? 'show-feature' : 'slide-bottom' : 'show-feature'}>
                        <div className='feature-info-column-left'>
                            <div className='text-heading'>
                                Never Leave Your Site
                            </div>
                            <p className='feature-info-paragraph text-description'>No redirecting with third-party links. No separate downloads. Your customers and assets stay with you.</p>
                            <div className='feature-image-normal'>
                                <img src="benefitNoRedirect.png" alt="custom-frame" className='feature-image' />
                            </div>
                        </div>
                    </Grid>
                    {/* Personalized Support */}
                    <Grid item xs={12} md={6} ref={ref3} className={isMdOrLarger ? inView3 ? 'show-feature' : 'slide-bottom' : 'show-feature'}>
                        <div className='feature-info-column-right'>
                            <div className='text-heading'>
                                Personalized Support
                            </div>
                            <p className='feature-info-paragraph text-description'>Connect with our dedicated team for tailored solutions and exceptional assistance.</p>
                            <div className='feature-image-normal'>
                                <img src="benefitSupport.png" alt="custom-frame" className='feature-image' />
                            </div>
                        </div>
                    </Grid>

                </Grid>
            </Container>
        </div>
    )

}

export default FeatureView;